import versionData from "@/version.json";

const appVersion = versionData.VERSION;
// const apiURL = import.meta.env.VITE_API_URL;

function HomePage() {
  return (
    <div className="app">
      <div className="w-full h-full flex flex-col">
        <div className="mx-auto my-auto">
          {appVersion}
          {/*, {apiURL} */}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
